<template>
  <img
    :alt="' county Indiana banner image'"
    :src="baseUrl + corpcode + '.webp'"
    class="img-fluid w-100 d-print-none"
    width="1020"
    height="129"
  />
</template>

<script>
export default {
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_LTI_URL
    };
  },
  props: {
    corpcode: {
      type: String,
      required: true
    }
  }
};
</script>
